export const iconFontAwesomeMapsMagnifyingGlassLocation = (
	<i className="fa-solid fa-magnifying-glass-location"></i>
);
